// composables/useSchemaOrg.js
import { useHead } from '#app';
import { unref, computed } from 'vue';

export const useSchemaOrg = (schema) => {
  useHead(computed(() => {
    const rawSchema = unref(schema);
    if (!rawSchema) return {};

    return {
      script: [
        {
          type: 'application/ld+json',
          innerHTML: JSON.stringify(rawSchema),
        }
      ],
    };
  }));
};